import {combineReducers} from 'redux';

import conversation from './conversation/reducer';
import newConversation from './new-conversation/reducer';
import conversationCenter from './conversation-center/reducer';
import inboxSearch from './search-box/reducer';
import messageComposer from './inbox-message-composer/reducer';
import newInboxConversation from './new-inbox-conversation/reducer';
import inboxMain from './inbox-main/reducer';

export default combineReducers({
    inboxMain,
    conversation,
    newConversation,
    conversationCenter,
    inboxSearch,
    messageComposer,
    newInboxConversation,
});
